import React from "react";

const LazyBoard = React.lazy(() => import("./Board").then((m) => ({ default: m.Board })));

export default LazyBoard;
